import { defineStore } from 'pinia'
import { type DropShipModel } from '../../types'

interface DropShipState {
  supportDropShip: boolean
  dropship: DropShipModel
}

export const useDropShip = defineStore('dropShip', {
  state: (): DropShipState => {
    return {
      supportDropShip: false,
      dropship: {
        addlProductionTime: 1,
        needDropShip: undefined,
        locationNum: '',
        needAddMore: undefined
      }
    }
  },
  getters: {
    getDropShip(): DropShipModel {
      return this.dropship
    },
    getNeedAddMore(): boolean | undefined {
      return this.dropship.needAddMore
    },
    /**
     * 是否选中drop ship
     */
    getNeedDropShip(): boolean | undefined {
      return this.dropship.needDropShip
    },
    getLocationNum(): number {
      if (this.dropship.locationNum =='')
        return 0
      
      return this.dropship.locationNum
    }
  },
  actions: {
    setDropship(state: DropShipModel) {
      this.$state.dropship = state
    },
    setNeedDropShip(val: boolean) {
      this.dropship.needDropShip = val
    },
    setNeedAddMore(val: boolean) {
      this.dropship.needAddMore = val
    },
    setSupportDropShip(val: boolean) {
      this.$state.supportDropShip = val
    }
  }
})
